export const RouteGroup = {
  /* ALPHABETICAL ORDER PLEASE */
  ACTIVITYLOG: 'activitylog',
  ADFLO_ORDERS_AGENT: 'adfloordersagent',
  AISUMMARIES: 'aisummaries',
  ALERTS: 'alerts',
  ANNOTATION: 'annotation',
  ANOMALIES: 'anomalies',
  AI_AGENTS: '/llm/aiagents',
  AI_CONTEXT: 'clients/ai-context',
  AI_CONTEXT_FILES: 'files',
  AI_CONTEXT_FILES_LOG: 'files/log',
  ASYNC: 'async',
  AUDIENCES: 'audience/activeaudiences?sort=-created_at',
  AUDIENCES_ARCHIVE: 'audience/archivedaudiences',
  AUDIENCES_UPLOAD_NEXT_FILE_AUDIENCE_CHUNK: 'audience/uploadNextFileAudienceChunk',
  AUDIENCES_UPLOAD_NEXT_SUPPRESSION_CHUNK: 'audience/uploadNextSuppressionChunk',
  AUDITLOGS: 'auditlogs',
  BADGES: 'badges',
  BILLING: 'billing',
  BILLINGREPORTS: 'billingreports',
  BILLING_ADDRESS: 'billing/address',
  BILLING_BILLINGDETAILS: 'billing/billingdetails',
  BILLING_CREDITCARD: 'billing/creditcard',
  BILLING_CUSTOMIZE: 'billing/customize',
  BILLING_INVOICES: 'billing/invoices',
  BILLING_MANAGEPLANS: 'billing/manageplans',
  BILLING_OVERVIEW: 'billing/overview',
  BITOOLS: 'bitools',
  BUDGETPACINGS: 'budgetpacings',
  BULKACTIVITYLOG: 'bulkactivitylog',
  BUNDLES: 'bundles',
  BUYSHEETS: 'buysheets',
  CALCULATIONS: 'calculations',
  CALCULATIONS_AI_PROMPT: 'calculations/ai/prompt',
  CANCELLATIONREASONS: 'cancellationreasons',
  CATEGORIES: 'categories',
  CATEGORIES_DRILLDOWN: 'categories/drilldown',
  CATEGORIES_OVERVIEW: 'categories/overview',
  CATEGORYDATA: 'categorydata',
  CATEGORY_METRICS: 'category_metrics',
  CATALOGUECHANNELS: 'cataloguechannels',
  CATALOGUESETTINGS: 'cataloguesettings',
  CHATGPTSUMMARIES_ITEMS: 'chatgptsummaryitems',
  CLIENTCATEGORIES: 'clientcategories',
  CLIENT_FORMS: 'clientforms',
  CLIENTGROUPS: 'clientgroups',
  CLIENTS: 'clients',
  CLIENTSPRODUCTS: 'clientsproducts',
  CLUSTERACCESSS: 'clusteraccesss',
  CLUSTERMEMBERS: 'clustermembers',
  CLUSTERS: 'clusters',
  COLUMNS: 'columns',
  COMMENT: 'comment',
  COMPARISON_OPTIONS: 'comparisonoptions',
  CONNECT_DATA: 'connectdata',
  CONNECTIONSTATUS: 'connectionstatus',
  CONTENTSETS: 'contentsets',
  CONTENTVALUES: 'contentvalues',
  CREATE_DASHBOARD: 'createdashboard',
  CREATIVES: 'creatives',
  CUSTOM_TRANSLATION_FORM: 'customtranslationsform:new',
  CUSTOM_TRANSLATIONS: 'customtranslations',
  FAV_DASH: 'fav/dash',
  DASH: 'dash',
  DASH_AI_WIDGET: 'dash/aiwidget',
  DASHBOARDS: 'dashboards',
  DASH_DASHBOARDFILTERS: 'dash/dashboardfilters',
  DASH_EXECUTIVE_SUMMARIES: 'dash/executivesummaries',
  DASH_FILES: 'dashfiles',
  DASH_FOLDERS: 'dashfolders',
  DASH_LAYOUTS: 'dash/layouts',
  DASH_PAGES: 'dash/pages',
  DASH_WIDGETS: 'dash/widgets',
  DASH_RECENT_FOLDERS: 'dashrecentfolders',
  DATAEXPORTERLOGS: 'dataexporterlogs',
  DATAEXPORTER_DAILY_EXPORT_STAT: 'dataexporterlogs/dailyexportstat',
  DATAEXPORTERS: 'dataexporters',
  DATASOURCES: 'datasources',
  DATAVIEWS: 'dataviews',
  DATALOADSTATUS: 'dataloadstatus',
  DATALOADSTATUS_DAILY_LOAD: 'dataloadstatus/dailyload',
  DATALOADSTATUS_DAILY_LOAD_STAT: 'dataloadstatus/summary/dailyloadstat',
  DATALOADSTATUS_DATA_LOAD: 'dataloadstatus/dataload',
  DATALOADSTATUS_MAPPING_STATUS: 'dataloadstatus/mappingstatus',
  DATALOADSTATUS_MAPPING_STATUS_BY_DATA_SOURCE: 'dataloadstatus/mappingstatus/summary/datasource',
  DATERANGE: 'daterange',
  DESIGNS: 'designs',
  DRILLDOWNS: 'drilldowns',
  EDITSETTINGS: 'editsettings',
  ENDCUSTOMERS: 'endcustomers',
  ENTITYFIELDS: 'entityfields',
  ENTITYFORMS: 'entityforms',
  ENTITYFORM_LINEITEMS: 'entityforms/product',
  ENTITYGROUPS: 'entitygroups',
  ENTITYITEMS: 'entityitems',
  ENTITYSTEPS: 'entitysteps',
  ENTITY_FIELD_AUDITLOGS: 'entityfieldauditlogs',
  ENTITY_FLIGHTS: 'entity/flights',
  ENTITY_LINEITEMS: 'entity/lineitems',
  ENTITY_ORDERCARTS: 'entity/ordercarts',
  ENTITY_ORDERS: 'entity/orders',
  ENTITY_PROPOSAL: 'entity/orders?status_type[]=proposal&rejection_data=true',
  EXECUTIVESUMMARIES: 'executivesummaries',
  EXECUTIVESUMMARIES_ITEMS: 'executivesummaries/items',
  EXPORT: 'export',
  EXPORTELEMENTS: 'exportelements',
  FEEDBACKS: 'feedbacks',
  FILE_TAGS: 'creatives/tags',
  FILE_UPLOAD_DRAFTS: 'file-upload-drafts',
  FILE_UPLOAD_DRAFTS_POLICY: 'policy',
  FILE_UPLOAD_DRAFTS_UPLOAD_CHUNK: 'upload-chunk',
  FILTERSETS: 'filtersets',
  FLIGHTSREPORTS: 'flightsreports',
  FLIGHTSWITHTASKSREPORTS: 'flightswithtasksreports',
  FLIGHTTASKSREPORTS: 'flighttasksreports',
  GENERIC: 'generic',
  GENERIC_DATA: 'generic_data',
  GLOBAL_FILTERS: 'globalfilters',
  GOALS: 'goals',
  GOALS_DATA: 'goals/data',
  GRANULAR_PERMISSIONS: 'granularpermissions',
  HINTREPORTS: 'hintreports',
  HISTORY: 'history',
  HUB: 'hub',
  IMPORT: 'import',
  IMPORTWIZARD: 'importwizard',
  INSIGHTS_HQ: 'insightshq',
  INSIGHTS_HQ_FILTERS: 'insightshq/filters',
  IOMASTER: 'iomaster',
  IOS: 'ios',
  ISPIONAGE_RESEARCH_AD_OTHER_KEYWORDS: 'ispionage/research/ad/other_keywords',
  ISPIONAGE_RESEARCH_DOMAIN_BACKLINKS_DATA: 'ispionage/research/domain/backlinks/data',
  ISPIONAGE_RESEARCH_DOMAIN_BACKLINKS_SUMMARY: 'ispionage/research/domain/backlinks/summary',
  ISPIONAGE_RESEARCH_DOMAIN_COMPARE_KEYWORDS: 'ispionage/research/domain/compare/keywords',
  ISPIONAGE_RESEARCH_DOMAIN_COMPARE_OVERLAP: 'ispionage/research/domain/compare/overlap',
  ISPIONAGE_RESEARCH_DOMAIN_COMPARE_STATS: 'ispionage/research/domain/compare/stats',
  ISPIONAGE_RESEARCH_DOMAIN_COUNTS: 'ispionage/research/domain/counts',
  ISPIONAGE_RESEARCH_DOMAIN_PPC_ADS: 'ispionage/research/domain/ppc/ads',
  ISPIONAGE_RESEARCH_DOMAIN_PPC_COMPETITOR_LPS: 'ispionage/research/domain/ppc/competitor/lps',
  ISPIONAGE_RESEARCH_DOMAIN_PPC_COMPETITORS: 'ispionage/research/domain/ppc/competitors',
  ISPIONAGE_RESEARCH_DOMAIN_PPC_KEYWORD_ADS: 'ispionage/research/domain/ppc/keyword/ads',
  ISPIONAGE_RESEARCH_DOMAIN_PPC_KEYWORDS: 'ispionage/research/domain/ppc/keywords',
  ISPIONAGE_RESEARCH_DOMAIN_PPC_LPS: 'ispionage/research/domain/ppc/lps',
  ISPIONAGE_RESEARCH_DOMAIN_SEO_COMPETITORS: 'ispionage/research/domain/seo/competitors',
  ISPIONAGE_RESEARCH_DOMAIN_SEO_GROUPS: 'ispionage/research/domain/seo/groups',
  ISPIONAGE_RESEARCH_DOMAIN_SEO_GROUP_KEYWORDS: 'ispionage/research/domain/seo/group/keywords',
  ISPIONAGE_RESEARCH_DOMAIN_SEO_KEYWORDS: 'ispionage/research/domain/seo/keywords',
  ISPIONAGE_RESEARCH_DOMAIN_SUMMARY_PPC_COUNTS: 'ispionage/research/domain/summary/ppc/counts',
  ISPIONAGE_RESEARCH_DOMAIN_SUMMARY_PPC_MONTHLY: 'ispionage/research/domain/summary/ppc/monthly',
  ISPIONAGE_RESEARCH_DOMAIN_SUMMARY_SEO_COUNTS: 'ispionage/research/domain/summary/seo/counts',
  ISPIONAGE_RESEARCH_DOMAIN_SUMMARY_SEO_MONTHLY: 'ispionage/research/domain/summary/seo/monthly',
  ISPIONAGE_RESEARCH_HISTORICAL: '/ispionage/research/historical',
  ISPIONAGE_RESEARCH_KEYWORD_PPC_ADS: 'ispionage/research/keyword/ppc/ads',
  ISPIONAGE_RESEARCH_KEYWORD_PPC_ADVERTISERS: 'ispionage/research/keyword/ppc/advertisers',
  ISPIONAGE_RESEARCH_KEYWORD_RELATED: 'ispionage/research/keyword/related',
  ISPIONAGE_RESEARCH_KEYWORD_SEO_COMPETITORS: 'ispionage/research/keyword/seo/competitors',
  ISPIONAGE_RESEARCH_KEYWORD_SUMMARY: 'ispionage/research/keyword/summary',
  ISPIONAGE_RESEARCH_ROWLIMIT: '/ispionage/research/rowlimit',
  ISPIONAGE_RESEARCH_SUGGEST: 'ispionage/research/suggest',
  ISPIONAGE_RESEARCH_USAGELIMIT: '/ispionage/research/usagelimit',
  LANGUAGES: 'languages',
  LAYOUTS: 'layouts',
  LAYOUTTAGS: 'layouttags',
  LEADS: 'leads',
  LEADNOTIFICATIONS: 'leadnotifications',
  LIBRARY: 'library',
  LIBRARY_DATASOURCES: 'library/datasources',
  LIBRARY_TEMPLATE: 'library/template',
  LINEITEMS: 'lineitems',
  LINEITEMSREPORTS: 'lineitemsreports',
  LINEITEMSWITHTASKSREPORTS: 'lineitemswithtasksreports',
  LINEITEMTASKSREPORTS: 'lineitemtasksreports',
  LOGIN: 'login',
  LOG: 'log',
  MAPBOX_ACCESS_TOKEN: 'mapboxaccesstoken',
  MANAGE_LEADS: 'admin/manageleads',
  MAPPING_CANDIDATE_HISTORY: 'mappingcandidatehistory',
  MARGINRULES: 'marginrules',
  MARKETPLACE_BILLING: 'marketplace/billing',
  METADATA: 'metadata',
  METRICS: 'metrics',
  NAMINGCONVENTIONS: 'namingconventions',
  NAMINGCONVENTIONS_CUSTOM: 'namingconventions/custom',
  NAVMAIN: 'navmain',
  NEWREPORTSTUDIOVIEW: 'new_reportstudioview',
  NOTES: 'notes',
  NOTIFBROADCAST: 'notifbroadcast',
  NOTIFTARGETED: 'notiftargeted',
  NOTIFICATIONPROFILES: 'notificationProfiles',
  OAUTH: 'oauth',
  OAUTH_AUTHORIZATIONUSER: 'oauth/authorizationusers',
  OAUTH_CLIENTS: 'oauth/clients',
  OAUTHUSERCLUSTERS: 'oauthuserclusters',
  OAUTHUSERS: 'oauthusers',
  OBJECTIVES: 'objectives',
  ORDERS: 'orders',
  ORDERSREPORTS: 'ordersreports',
  ORDERSWITHTASKSREPORTS: 'orderswithtasksreports',
  ORDERTASKSREPORTS: 'ordertasksreports',
  PAGES: 'pages',
  PAGETAGS: 'pagetags',
  PLATFORMSEARCH: 'platformsearch',
  PLOTTYPES_MAPBOXLAYERS: 'plottypes/mapboxlayers',
  PREFERENCES: 'preferences',
  PRODUCT_FORMS: 'productforms',
  PRODUCTS: 'products',
  PROJECT_FORMS: 'orderforms',
  PROPOSALS: 'proposals',
  QUEUE: 'queue',
  QUEUES: 'queues',
  REMOVE_FILTER_SET: 'removefilterset',
  RELATIONSHIPS: 'relationships',
  REPORTINGPROFILES: 'reportingprofiles',
  REPORTINGTEMPLATES: 'reportingtemplates',
  REPORTSTUDIO: 'reportstudio',
  REPORTSTUDIO_LIBRARY: 'reportstudio/library',
  REPORTSTUDIO_TAGS: 'reportstudio/tags',
  RESEARCH: '/raven/research',
  ROLES: 'roles',
  SAMPLE: 'sample',
  SAVECOLUMNPREFERENCES: 'savecolumnpreferences',
  SCHEDULEDREPORTS: 'scheduledreports',
  SERVER_API: 'server/api',
  SERIVCECAMPAIGNS: 'service',
  SERVICE_MAPPINGS: 'service/mappings',
  SERVICECLIENTMAPPING: 'serviceclientmapping',
  SERVICECLIENTMAPPING_LOG: 'serviceclientmapping/log',
  SERVICECLIENTMAPPING_LOG_DETAIL: 'serviceclientmapping/log/detail',
  SERVICECLIENTMAPPING_TEST: 'serviceclientmapping/test',
  SERVICECLIENTMAPPINGS: 'serviceclientmappings',
  SERVICELOOKUPS: 'servicelookups',
  SERVICES: 'services',
  SERVICES_DRILLDOWN: 'services/drilldown',
  SERVICES_MANAGE: 'services/manage',
  SERVICES_ORDERITEMS: 'services/orderitems',
  SERVICES_ORDERS: 'services/orders',
  SERVICES_OVERVIEW: 'services/overview',
  SERVICES_SETTINGS: 'services/settings',
  SERVICESETTINGS: 'servicesettings',
  SEO_ONBOARD_CHECKLIST: 'seo/onboard/checklist',
  SEO_WEBSITES: 'seo/websites',
  SEO_WEBSITES_USAGE: 'seo/websites/usage',
  SERP: 'serp',
  SERP_KEYWORD_USAGE: 'serp/keyword-usage',
  SERP_OVERVIEW: 'serp/overview',
  SERP_SEARCH_LOCATIONS: 'serp/search/locations',
  SERP_SUGGEST_ENGINES: 'serp/suggest/engines',
  SERP_SUGGEST_KEYWORDS: 'serp/suggest/keywords',
  SESSION: 'session',
  SITEAUDITOR: 'siteauditor',
  SITEAUDITOR_CRAWLSESSIONS: 'siteauditor/crawlsessions',
  SITEAUDITOR_ISSUES: 'siteauditor/issues',
  SITEAUDITOR_OVERVIEW: 'siteauditor/overview',
  SITEAUDITOR_PAGES: 'siteauditor/pages',
  SITEAUDITOR_PAGESPEED: 'siteauditor/pagespeed',
  SITEAUDITOR_SITES: 'siteauditor/sites',
  SMARTCAMPAIGNS: 'smartcampaigns',
  SPARKLINE_OPTIONS: 'sparklineoptions',
  STATUSES: 'statuses',
  STATUSTEMPLATES: 'statustemplates',
  SUMMARYCOLUMNS: 'summarycolumns',
  SUMMARYCSV: 'summarycsv',
  SUP_SERVICE_MANAGE: 'sup/service/manage',
  TAGS: 'tags',
  TAGVALUES: 'tagvalues',
  TASK: 'task',
  TASK_FORMS: 'taskforms',
  TASK_STATUSES: 'task/statuses',
  TASKS: 'tasks',
  TASKTAGS: 'tasktags',
  TASKTEMPLATEACTIONS: 'tasktemplateactions',
  TASKTEMPLATES: 'tasktemplates',
  TESTGOALS: 'sup/goals',
  THEMEBUILDER: 'themebuilder',
  THUMBNAIL_LOGS: 'thumbnail/logs',
  TIMEGROUPINGS: 'timegroupings',
  TO_CONNECTORS: 'toconnectors',
  TRANSFORMATIONHUB: 'transformationhub',
  TRANSFORMATIONHUB_ASSISTANT: 'transformationhub/assistant',
  UPDATE_THUMBNAIL: 'updatethumbnail',
  USERS: 'users',
  USERIMAGES: 'userimages',
  USERLOGINS: 'userlogins',
  VALUE_SET: 'values/set',
  WEBHOOKS: 'webhooks',
  WIDGETS: 'widgets',
  WIDGETTAGS: 'widgettags',
  WORKFLOWACTIONS: 'workflowactions',
  /* ALPHABETICAL ORDER PLEASE */
};

export const LegacyRouteGroup = {
  CLIENT: 'client',
  GETLOGOURL: 'api/getLogoUrl',
  REPORTINGTEMPLATE: 'reportingTemplate',
  REPORTING_GETNEXTSENDDATES: 'reporting/get_next_send_dates',
  REPORTING_DOWNLOADCSVSCHEDULEDREPORTLIST: 'reporting/download_csv_scheduled_report_list',
  APEXTRANSCRIPTVIEWER_TRANSCRIPT: 'apextranscriptviewer/transcript',
};

/**
 * These are the frontend routes which don't have a backend
 * route or differently named backend route.
 * Eg: server/api/dash/1 can be /dashboards/1 in front end
 */
export const PseudoRoute = {
  WELCOME: 'welcome',
  ONBOARDING: 'onboarding',
  RAVEN_WEBSITES: 'raven/websites',
  RAVEN_GETTING_STARTED: 'raven/gettingstarted',
  SHEETS_GETTINGSTARTED: 'sheets/gettingstarted',
  SHEETS_TEMPLATES: 'sheets/templates',
  GDS_GETTINGSTARTED: 'gds/gettingstarted',
};

export const EntityName = {
  AUDIENCES: 'audiences',
};

export const DataQuery = {
  TYPE_CONCAT: 'concat',
  TYPE_GROUP_CONCAT: 'group_concat',
  TYPE_JSON_CONCAT: 'json_concat',
  TYPE_DISTINCT_GROUP_CONCAT: 'distinct_group_concat',
  TYPE_JSON_OBJ_AGGREGATE: 'json_obj_aggregate',
  TYPE_CONCAT_MULTI_COLUMN: 'concat_multi_column',

  // Numeric query types
  TYPE_COUNT: 'count',
  TYPE_COUNT_DISTINCT: 'count_distinct',
  TYPE_SUM: 'sum',
  TYPE_AVERAGE: 'average',
  TYPE_PERCENTAGE: 'percentage',
  TYPE_SUM_OVER_SUM: 'sumoversum',
  TYPE_MAX: 'max',

  TYPE_CUSTOM: 'custom',
};

export const ResponseType = {
  CODE: 'code',
};
